import { Routes, Route, useParams, Navigate } from 'react-router-dom';

import PageCustomizableContainer from 'hb-react/shared/apps/PageCustomizables/containers/PageCustomizableContainer';

const PageCustomizableRoute = ({ fetchPath, ...props }) => {
  const { slug } = useParams();

  return <PageCustomizableContainer url={fetchPath(slug)} {...props} />;
};

export default (props) => (
  <Routes>
    <Route path="/:slug" element={<PageCustomizableRoute {...props} />} />
    <Route
      path="*"
      element={<Navigate to={props?.redirectUrl || '/'} replace />}
    />
  </Routes>
);
